<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col class="px-8 py-4 d-none d-sm-flex" cols="auto">
        <v-img
          v-if="artworkResp.src"
          :aspect-ratio="aspectRatio"
          :sizes="artworkResp.sizes"
          :src="artworkResp.src"
          :srcset="artworkResp.srcset"
          alt="Artwork for banner"
          cover
          max-width="100"
          width="100"
        />
      </v-col>

      <v-col class="py-md-6 pr-3 pr-sm-8" cols="12" sm="">
        <h3
          v-if="value.title"
          :class="value.description ? 'mb-2' : ''"
          class="text-h6 text-sm-h5"
        >
          <StyledText
            :value="value.title"
            :em-class="
              value.color_scheme && value.color_scheme.em_text_color
                ? `text-${value.color_scheme.em_text_color.id} font-weight-medium`
                : `text-light-blue-darken-2 font-weight-medium`
            "
          />
        </h3>

        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="value.description"
          class="text-body-1"
          v-html="value.description"
        ></div>

        <div v-if="ctas && ctas.length">
          <CtaButton
            v-for="(cta, i) in ctas"
            :key="cta.id"
            :class="i < ctas.length - 1 ? 'mr-6' : ''"
            :primary-color="
              value.color_scheme && value.color_scheme.primary_button_color
                ? value.color_scheme.primary_button_color.id
                : undefined
            "
            :secondary="i > 0"
            :secondary-color="
              value.color_scheme && value.color_scheme.secondary_button_color
                ? value.color_scheme.secondary_button_color.id
                : undefined
            "
            :value="cta.ctas_id"
            class="text-none my-3"
            rounded="pill"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, toRef } from 'vue'
import { useImgResponsive } from '#root/lib/img'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 1
const artworkResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.artwork ? props.value.artwork : undefined,
    sizes: {
      xs: '400px'
    }
  }))
)

const ctas = computed(() => {
  return (
    props.value &&
    props.value.ctas &&
    props.value.ctas.filter(cta => cta.ctas_id.status === 'published')
  )
})
</script>
